package ui.pages

import emotion.react.css
import helpers.isMiniDesktop
import helpers.isPhone
import js.lazy.Lazy
import react.FC
import react.dom.html.ReactHTML
import react.router.dom.NavLink
import react.router.useLocation
import react.useContext
import react.useEffect
import ru.malygin.myConst.jsMainDebugUnit
import ui.component.buttons.iconButton
import ui.component.external.*
import ui.router.RouterRoute
import ui.styles.Styles
import ui.styles.icons.*
import ui.themePlusContext.*
import web.cssom.AlignItems
import web.cssom.Color
import web.cssom.None
import web.cssom.pct
import kotlin.random.Random

@Lazy
val Header = FC {

    val ctx = useContext(MyContext)
    val testCtx = useLoadDataContext()
    val localLocation = useLocation()
    val toast = useContext(ToastContext)
    val phone = isPhone()
    val miniDesktop = isMiniDesktop()
    val dialog = NewDialog

    val moveToUrl: String
    val useIcon: IconsSVG
    val displayElements: Boolean

    if (localLocation.pathname == RouterRoute.MAIN_PAGE.route){
        moveToUrl = RouterRoute.CHANGE_SCHEDULE.route
        useIcon = EditNoteIconSVG
        displayElements = true
    }else{
        moveToUrl = RouterRoute.MAIN_PAGE.route
        useIcon = ArrowBackIconSVG
        displayElements = false
    }

    ReactHTML.header{
        className = Styles.Header.headerBox

        ReactHTML.div{
            className = Styles.Header.headerTitle


            ReactHTML.span{
                css {
                    color = Color("white")
                }
                +"${ctx.name}"
            }
        }

        ReactHTML.div{
            className = Styles.Header.headerLeftBlock

            css(this.className) {
                alignItems = AlignItems.center
            }

            iconButton{
                displayElement = displayElements
                realIconSVG = MenuRoundedIconSVG
                plusMessageRight = if (phone) null else MenuRoundedIconSVG.description.split(" ").getOrNull(1)?.replaceFirstChar { it.uppercase() }
                onClick = {
                    drawerOpenClose(true)
                }
            }
            jsMainDebugUnit{
                iconButton{
                    realIconSVG = CloseRoundedIconSVG
                    onClick = {
//                        toast.open(ToastData(
//                            message = "123123Test_${Random.nextInt(0, 100)}_${testCtx.isLoading}",
//                            type = ToastTypes.entries.random()
//                        ))
//
//                        testCtx.rebuildMainList()
                        toggleDialog(NewDialogEnum.ON_START_DIALOG)
                    }
                }
            }
            if (miniDesktop){
                ReactHTML.div{

                    css {
                        width = 30.pct
                    }

                    themeSwitch{
                        this.heightSize = (Sizes.Header.HEIGHT_NOT_PX * 0.6).toInt()
                        this.deleteTitle = true
                    }
                }
            }
        }

        ReactHTML.div{
            className = Styles.Header.headerRightBlock

            css(this.className) {
                alignItems = AlignItems.center
            }

            NavLink{
                css {
                    textDecoration = None.none
                }
                to = moveToUrl
                title = useIcon.description
                iconButton{
                    plusMessageLeft = if (phone) null else useIcon.description
                    realIconSVG = useIcon
                }
            }
        }
    }
}